import { jsx as _jsx } from "react/jsx-runtime";
import { BadgeNewStyled } from './BadgeNew.styled';
export const BadgeNew = () => {
    return _jsx(BadgeNewStyled, { children: "New" }, void 0);
};
//# sourceMappingURL=BadgeNew.js.map